import React, { SelectHTMLAttributes } from "react";
import { ArrowIcon, SelectContainer, StyledSelect } from "./styles";

export interface Option {
  label: string;
  value: string | number;
}

interface CustomSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: Option[];
}

export const CustomSelect: React.FC<CustomSelectProps> = ({
  options,
  ...props
}) => {
  return (
    <SelectContainer>
      <StyledSelect {...props}>
        {options.map((option, idx) => (
          <option key={idx} value={option.value}>
            {option.label}
          </option>
        ))}
      </StyledSelect>
      <ArrowIcon />
    </SelectContainer>
  );
};

export default CustomSelect;
